import { isLocalhost } from '../../../shared/helpers/functions/env';

export const getBasename = () => (isLocalhost() ? '/planSelect' : '');
